import React from 'react'
import { useTranslation } from 'react-i18next'

const MaxCardInverter: React.FC<{
  dailyPV: string
  dailyCharge: string
  dailyConsumption: string
  dailySales: string
}> = ({ dailyPV, dailyCharge, dailyConsumption, dailySales }) => {
  const { t } = useTranslation()

  return (
    <div className='flow-MaxCardInverter' id='Flow-inverter'>
      <div className='flow-MaxCardInverter-top'>
        <img src='/assets/image/inverter.png' />
        <div className='separator'></div>
        <div className='flow-content'>
          <div className='flow-one-row'>
            <div className='flow-one-item'>
              <div className='title'>{t('site.dailyPv')}</div>
              <div className='value'>{dailyPV}kWh</div>
            </div>
            <div className='flow-one-item'>
              <div className='title'>{t('site.dailyCharge')}</div>
              <div className='value'>{dailyCharge}kWh</div>
            </div>
          </div>
          <div className='flow-one-row'>
            <div className='flow-one-item'>
              <div className='title'>{t('site.dailyConsumption')}</div>
              <div className='value'>{dailyConsumption}kWh</div>
            </div>
            <div className='flow-one-item'>
              <div className='title'>{t('site.dailySale')}</div>
              <div className='value'>{dailySales}kWh</div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className='flow-MaxCardInverter-top-bottom'>
          {chosenDevice ? <span>{formatDate(new Date(chosenDevice.create_time))}</span> : ''}
          <span>
            <span></span>
          </span>
        </div> */}
    </div>
  )
}

export default MaxCardInverter
